<template>
  <div
    class="vs-list--header"
    :class="[`vs-header-list-${color}`, { 'with-icon': icon }]"
    :style="headerStyle"
  >
    <div v-if="icon" class="vs-list--icon">
      <vs-icon :icon-pack="iconPack" :icon="icon" />
    </div>
    <div class="list-titles">
      <div v-if="title" class="vs-list--title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VsListHeader",
  props: {
    color: {
      type: String,
      default: "primary",
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
  },
  computed: {
    headerStyle() {
      if (
        this.color.startsWith("#") ||
        this.color.startsWith("rgb") ||
        this.color.startsWith("hsl") ||
        this.color.startsWith("var(")
      ) {
        return { color: this.color };
      }
      return { color: `rgba(var(--vs-${this.color}), 1)` };
    },
  },
};
</script>
